import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import {
  askSubTabList,
  customerServiceTabList,
} from "../../constant/customerServiceTab";
import LSBdBody01 from "./../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import { route } from "../../router/route";
import MainBtn from "./../../components/atoms/button/mainBtn";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import LSBdCaption02 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption02";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import AskApi from "../../api/ask.api";
import { fileUrl } from "../../api/api";
import moment from "moment";
import { toast } from "react-toastify";
import { macOSCheck } from "../../util/macOSCheck";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";

const CustomerServiceAskDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { id } = useParams();
  const userId = sessionStorage.getItem("id");
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    const tokenData = sessionStorage.getItem("token");

    setToken(tokenData);

    if (!Number.isInteger(Number(id)) || Number(id) < 1) {
      toast("잘못된 문의 경로입니다.");
      navigate(route.customer_service_ask, { replace: true });
      return;
    }

    getAskData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 게시물 데이터 가져오기 ---------- //
  const [askData, setAskData] = useState({});

  const getAskData = async () => {
    try {
      const response = (await AskApi.getDetail(id)).data.data.content;

      setAskData(response);
    } catch (error) {
      console.error(error);
      toast("문의 내용을 불러오지 못했습니다.");
      navigate(route.customer_service_ask, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- 삭제 관련 ---------- //
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDelete = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      const data = {
        ids: [Number(id)],
        allFlag: false,
      };
      await AskApi.delete(data);
      toast("문의가 삭제되었습니다.");
      navigate(
        location.state?.isMy
          ? route.customer_service_ask_my
          : route.customer_service_ask,
        { replace: true },
      );
    } catch (error) {
      console.error(error);
      toast("문의 삭제에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setIsDeleting(false);
      setIsModalOpen(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📢 고객센터
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {customerServiceTabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 1 ? true : false}
                    title={tab.title}
                  />

                  {index === 1 && (
                    <SubTabWrapper>
                      {askSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            if (!token && index === 1) {
                              navigate(route.login);
                              return;
                            }

                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <WhiteBoxContain>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 24,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        border: "1px solid",
                        borderColor: !askData.answerFlag
                          ? "#a4a8b1"
                          : "#5050FF",
                        borderRadius: 30,
                        padding: "4px 14px",
                        alignSelf: "flex-start",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <LSBdBody01
                        style={{
                          color: !askData.answerFlag ? "#a4a8b1" : "#5050FF",
                          marginTop: macOSCheck() ? 0 : 2,
                        }}
                      >
                        {!askData.answerFlag ? "답변대기" : "답변완료"}
                      </LSBdBody01>
                    </div>
                    <LSBdDisplay02
                      style={{
                        color: "#000000",
                      }}
                    >
                      {askData?.title || ""}
                    </LSBdDisplay02>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: "16px 0px",
                    borderTop: "1px solid #DBDDE0",
                    borderBottom: "1px solid #DBDDE0",
                  }}
                >
                  <img
                    style={{
                      height: 40,
                      width: 40,
                      marginRight: 16,
                      borderRadius: 999,
                    }}
                    src={
                      askData?.member?.profileServerFileName
                        ? `${fileUrl}/${askData?.member?.profileServerFileName}`
                        : "/assets/icons/profile.png"
                    }
                    alt="profile"
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <LSBdBody01
                      style={{
                        color: "#000000",
                      }}
                    >
                      {askData?.member?.nickname || ""}
                    </LSBdBody01>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <LSRgCaption02
                        style={{
                          color: "#898e99",
                          marginRight: 24,
                        }}
                      >
                        {moment(askData.createdAt).format("YYYY.MM.DD")}
                      </LSRgCaption02>
                    </div>
                  </div>
                </div>

                <LSRgH1HeadLine
                  style={{
                    color: "#000000",
                    marginTop: 30,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {askData?.content || ""}
                </LSRgH1HeadLine>
                {Number(askData?.member?.id) === Number(userId) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 10,
                      marginTop: 30,
                    }}
                  >
                    {askData.answerFlag ? null : (
                      <MainBtn
                        onClick={() => {
                          navigate(
                            `${route.customer_service_ask_edit}/${askData.id}`,
                          );
                        }}
                        style={{
                          background: "#F6F7F8",
                          border: "1px solid #F6F7F8",
                          height: 36,
                          width: 72,
                        }}
                      >
                        <LSRgBody01
                          style={{
                            color: "#a4a8b1",
                            textAlign: "center",
                            marginTop: macOSCheck() ? 0 : 2,
                          }}
                        >
                          수정
                        </LSRgBody01>
                      </MainBtn>
                    )}

                    <MainBtn
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                      isNegative={true}
                      style={{
                        height: 36,
                        minWidth: 72,
                        width: "fit-content",
                        padding: "0px 25px",
                      }}
                    >
                      <LSRgBody01
                        style={{
                          color: "#FFFFFF",
                          textAlign: "center",
                          marginTop: macOSCheck() ? 0 : 2,
                        }}
                      >
                        삭제
                      </LSRgBody01>
                    </MainBtn>
                  </div>
                )}
              </WhiteBoxContain>

              {/* 답변이 있는 경우 */}
              {askData.answerFlag && (
                <WhiteBoxContain
                  style={{
                    marginTop: 40,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "100%",
                      paddingBottom: 16,
                      borderBottom: "1px solid #DBDDE0",
                    }}
                  >
                    <LSBdH2HeadLine
                      style={{
                        color: "#5050FF",
                      }}
                    >
                      문의 답변
                    </LSBdH2HeadLine>
                  </div>

                  <div
                    style={{
                      marginTop: 16,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <LSRgH1HeadLine
                      style={{
                        color: "#000000",
                        margin: "8px 0px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {askData?.answer || ""}
                    </LSRgH1HeadLine>
                  </div>
                  <LSRgCaption02 style={{}}>
                    {moment(askData?.updatedAt).format("YYYY.MM.DD HH:mm")}
                  </LSRgCaption02>
                </WhiteBoxContain>
              )}
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 41,
                height: 12,
                padding: "4px 0px",
                cursor: "pointer",
                marginBottom: 20,
              }}
              onClick={() => {
                navigate(-1);
              }}
            >
              <LSRgCaption01>{"< 이전으로"}</LSRgCaption01>
            </div>
            <WhiteBoxContain
              $isSmall={isSmall}
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  marginBottom: 24,
                }}
              >
                <div
                  style={{
                    border: "1px solid",
                    borderColor: !askData.answerFlag ? "#a4a8b1" : "#5050FF",
                    borderRadius: 30,
                    padding: "6px 14px",
                    alignSelf: "flex-start",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <LSBdBody01
                    style={{
                      color: !askData.answerFlag ? "#a4a8b1" : "#5050FF",
                    }}
                  >
                    {!askData.answerFlag ? "답변대기" : "답변완료"}
                  </LSBdBody01>
                </div>
                <LSBdH2HeadLine>{askData?.title || ""}</LSBdH2HeadLine>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "8px 0px",
                  borderTop: "1px solid #DBDDE0",
                  borderBottom: "1px solid #DBDDE0",
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <img
                    style={{
                      height: 40,
                      width: 40,
                      borderRadius: 999,
                    }}
                    src={
                      askData?.member?.profileServerFileName
                        ? `${fileUrl}/${askData?.member?.profileServerFileName}`
                        : "/assets/icons/profile.png"
                    }
                    alt="profile"
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      gap: 4,
                    }}
                  >
                    <LSBdCaption02>
                      {" "}
                      {askData?.member?.nickname || ""}
                    </LSBdCaption02>
                    <LSRgCaption01>
                      {" "}
                      {moment(askData.createdAt).format("YYYY.MM.DD")}
                    </LSRgCaption01>
                  </div>
                </div>
              </div>

              <LSRgBody01
                style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
              >
                {askData?.content || ""}
              </LSRgBody01>

              {Number(askData?.member?.id) === Number(userId) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginTop: 20,
                  }}
                >
                  {askData.answerFlag ? (
                    <div
                      style={{
                        width: "100%",
                      }}
                    />
                  ) : (
                    <MainBtn
                      onClick={() => {
                        navigate(
                          `${route.customer_service_ask_edit}/${askData.id}`,
                        );
                      }}
                      style={{
                        background: "#F6F7F8",
                        border: "1px solid #F6F7F8",
                        height: 36,
                      }}
                    >
                      <LSRgBody01
                        style={{
                          color: "#a4a8b1",
                          textAlign: "center",
                        }}
                      >
                        수정
                      </LSRgBody01>
                    </MainBtn>
                  )}

                  <MainBtn
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                    isNegative={true}
                    style={{
                      height: 36,
                    }}
                  >
                    <LSRgBody01
                      style={{
                        color: "#FFFFFF",
                        textAlign: "center",
                      }}
                    >
                      삭제
                    </LSRgBody01>
                  </MainBtn>
                </div>
              )}
            </WhiteBoxContain>

            {/* 답변이 있는 경우 */}
            {askData.answerFlag && (
              <WhiteBoxContain
                $isSmall={isSmall}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <LSBdBody02 style={{ color: "#5050FF" }}>문의 답변</LSBdBody02>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderTop: "1px solid #DBDDE0",
                    marginTop: 12,
                    paddingTop: 20,
                  }}
                >
                  <LSRgCaption02
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {askData?.answer || ""}
                  </LSRgCaption02>

                  <LSRgCaption01
                    style={{
                      marginTop: 8,
                    }}
                  >
                    {moment(askData?.updatedAt).format("YYYY.MM.DD HH:mm")}
                  </LSRgCaption01>
                </div>
              </WhiteBoxContain>
            )}
          </ContentContainer>
        </MOContainer>
      )}

      {/* 모달 */}
      {isModalOpen && (
        <ConfirmModal
          isScroll={false}
          isNegative={true}
          title={
            isDeleting
              ? "문의를 삭제하고 있습니다."
              : "문의를 삭제하시겠습니까?"
          }
          onClick={() => {
            setIsModalOpen(false);
          }}
          onYClick={handleDelete}
        />
      )}
    </HomeSection>
  );
};

export default CustomerServiceAskDetail;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: rgba(237, 237, 255, 0.5);
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const WhiteBoxContain = styled.div`
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
  padding: ${(props) => (props.$isSmall ? "30px 20px" : "40px")};
  width: 100%;
  border-radius: 15px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;
